module.exports = __webpack_public_path__ + "img/[咒骂].6d8f625b.svg";